import { Component, OnInit } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';

@Component({
  selector: 'app-security-level',
  templateUrl: './security-level.component.html',
  styleUrls: ['./security-level.component.css']
})
export class SecurityLevelComponent implements OnInit {
  pageTitle: any = '';

  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    this.navService.titleSub.subscribe(res => {
      // console.log(res);
      this.pageTitle = res;
    })
  }

}
